export default "__VITE_ASSET__XEx9saDM__"